<template>
  <BlBackdrop
    title="Delete member"
    label="Yes, delete member"
    type="error"
    :submitLoading="submitLoading"
    :disabled="isDisabledSubmit"
    @backdrop-close="$emit('close-modal')"
    @backdrop-action="onSubmit"
  >
    <div class="flex flex-col gap-3 px-8">
      <div v-if="appointmentChecking" class="h-64 grid place-items-center">
        <div class="blum-loader"></div>
      </div>
      <div v-else-if="userAppointments.length" class="flex flex-col gap-2">
        <div>
          <BlTextBody2 text="This action will affect" />
          <BlTextBody2 :text="totalAppointments" class="font-bold" />
          <BlTextBody2 text="scheduled appointment(s)." />
          <BlTextBody2
            text="Please resolve the appointment(s) before proceeding with the deletion."
          />
        </div>
        <div
          class="max-h-64 py-3 px-4 flex flex-col gap-1 bg-slate-200 rounded overflow-y-auto"
        >
          <div
            class="sticky top-0 z-10 w-44 py-1 px-2 flex items-center gap-2 bg-light-purple-100 rounded cursor-pointer"
            @click="onCheckAppointment"
          >
            <BlIcon
              icon="update"
              class="h-4 w-4"
              :class="{ 'animate-spin': appointmentChecking }"
            />
            <BlTextBody3
              text="Refresh appointments"
              class="text-light-purple flex-shrink-0"
            />
          </div>
          <div
            v-for="item in userAppointments"
            :key="item.date"
            class="flex items-center justify-between"
          >
            <div class="flex items-center gap-2">
              <BlTextBody2
                :text="`${displayDate({ date: item.date })}:`"
                class="text-slate-600"
              />
              <BlTextBody2
                :text="`${item.appointments.length} appointment(s)`"
                class="text-slate-800"
              />
            </div>
            <router-link
              :to="
                `/appointments/therapist?page=1&per_page=25&user_id=${user.id}&status=scheduled,in_progress&preview_type=list`
              "
              target="_blank"
            >
              <BlInputButton type="outlined" dense label="View" />
            </router-link>
          </div>
        </div>
      </div>

      <div>
        <BlTextBody2 text="Are you sure you want to delete" />
        <BlTextBody2 :text="`${user.name}?`" class="font-bold" />
        <BlTextBody2
          text="Once deleted, they will no longer have access to Blüm."
        />
        <BlTextBody2
          text="Additionally, all data associated with this user will be tagged as"
        />
        <BlTextBody2 text="''Deleted User''." class="font-bold" />
      </div>
    </div>
  </BlBackdrop>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { displayDate } from "@/plugins/helper.js";

import BlBackdrop from "../BlBackdrop.vue";
import BlTextBody2 from "../BlTextBody2.vue";
import BlTextBody3 from "../BlTextBody3.vue";
import BlInputButton from "../BlInputButton.vue";
import BlIcon from "../BlIcon.vue";

export default {
  name: "DeletedUserModal",
  components: {
    BlBackdrop,
    BlTextBody2,
    BlTextBody3,
    BlInputButton,
    BlIcon
  },
  props: {
    user: { type: Object, required: true }
    // @close-modal
  },
  data() {
    return {
      submitLoading: false,
      appointmentChecking: false,
      userAppointments: []
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
    totalAppointments() {
      let n = 0;
      this.userAppointments.forEach(i => {
        n += i.appointments.length;
      });
      return n;
    },
    isDisabledSubmit() {
      if (this.appointmentChecking) return true;
      if (this.userAppointments.length > 0) return true;
      return false;
    }
  },
  watch: {},
  mounted() {
    this.onCheckAppointment();
  },
  methods: {
    ...mapActions(["checkUserAppointments", "deleteUser"]),
    displayDate,
    async onCheckAppointment() {
      const params = { id: this.user.id };

      this.appointmentChecking = true;
      const { success, data } = await this.checkUserAppointments(params);
      this.appointmentChecking = false;
      if (!success) {
        this.$emit("close-modal");
        return;
      }
      this.userAppointments = data;
    },
    async onSubmit() {
      const params = { id: this.user.id };

      this.submitLoading = true;
      const { success } = await this.deleteUser(params);
      this.submitLoading = false;
      if (!success) return;
      this.$emit("close-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/team/DeleteUserModal.vue